import moment from "moment-timezone";
import DataTable from "react-data-table-component";

const FeedbackList = ({ myData, onImageClick }) => {
  const columnDefs = [
    {
      name: "Name",
      selector: (row) => row?.name,
      sortable: true,
    },
    {
      name: "Inquiry Type",
      selector: (row) => row?.queryType,
      sortable: true,
    },
    {
      name: "Email",
      selector: (row) => row?.email,
      sortable: true,
    },
    {
      name: "Date",
      selector: (row) => moment(row?.createdAt).format("DD/MM/YYYY HH:mm"),
      sortable: true,
    },
    {
      name: "Message",
      selector: (row) => row?.message,
      sortable: false,
      cell: (row) => (
        <div
          style={{
            maxWidth: 250,
            whiteSpace: "normal",
            wordBreak: "break-word",
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
          }}
        >
          {row?.message}
        </div>
      ),
    },
    {
      name: "View",
      cell: (row) => (
        <button
          className="btn btn-sm btn-primary"
          onClick={() =>
            onImageClick?.(row.attachment, row.message, row?.attachmentType)
          }
        >
          View
        </button>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  return (
    <DataTable
      data={myData}
      columns={columnDefs}
      pagination
      selectableRows
      onSelectedRowsChange={(e) => console.log("Selected Rows:", e)}
    />
  );
};

export default FeedbackList;
